import React from "react";
import { Link } from "react-router-dom";
import paths from "../../../routes/paths";
import logo from "../../../assets/images/ncici/logo.jpg";
import { FaShoppingCart } from "react-icons/fa";
const Header = () => {
  return (
    <div className=" ">
      <div class="navbar  px-10 z-50 ">
        <div className="navbar-start">
          <Link
            to={paths.home}
            className="hover:scale-105 transition-all normal-case rounded-full"
          >
            <img className="rounded-full" src={logo} width={80} height={80} />
          </Link>
        </div>
        <div class="navbar-center">
          <ul class=" flex gap-3 ">
            <li className="p-1 nav-link text-sm titlefont">
              <Link to={paths.home}>Home</Link>
            </li>
            <li className="p-1 nav-link text-sm titlefont">
              <a href="https://nccoutlet.com/shop">shop</a>
            </li>
          </ul>
        </div>
        <div class="navbar-end">
          <div class="row">
            <label tabindex="0" class="btn btn-ghost btn-circle">
              <a href="https://nccoutlet.com/">
                <FaShoppingCart size={24} color="#483285" />
              </a>
            </label>
            {/* <label tabindex="0" class="btn btn-ghost btn-circle"></label>
            <label tabindex="0" class="btn btn-ghost btn-circle"></label> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
